// Payment gateway integration utilities
// Handles Paystack and Stripe initialization and redirection
import axios from "axios";

export const startPaystackPayment = async ({
  email,
  amount,
  currency,
  reference,
  metadata,
  publicKey,
}) => {
  return new Promise((resolve, reject) => {
    if (!window.PaystackPop) {
      const script = document.createElement("script");
      script.src = "https://js.paystack.co/v1/inline.js";
      script.onload = () => launch();
      document.body.appendChild(script);
    } else {
      launch();
    }
    function launch() {
      const handler = window.PaystackPop.setup({
        key: publicKey,
        email,
        amount: Math.round(amount * 100), // Paystack expects kobo/cent
        currency,
        ref: reference,
        metadata,
        callback: (response) => resolve(response),
        onClose: () => reject(new Error("Payment closed")),
      });
      handler.openIframe();
    }
  });
};

export const startStripePayment = async ({ sessionUrl }) => {
  window.location.href = sessionUrl;
};

// Backend endpoints should provide Paystack public key and Stripe session URL
